import PageHandlersService from '@/utils/page-handlers-service';
import axios from 'axios';
import gsap from 'gsap';

//  Мой ключ нужно будет стереть
const API_KEY = 'bf7f945c6ebcbc7cd10d4925fadb6be2aa19f74d';

interface ISuggestionsItem {
    value: string;
}

interface IAutocompleteResponse {
    suggestions: ISuggestionsItem[];
}

let selectedCity = [];

const adressInput = document.querySelector<HTMLInputElement>('.js-address-handler');

const pageHandlers = new PageHandlersService();

const CHECK_PAYMENT_INPUT_VALUES = ['2', '5'];

function citySettlementCheck(input: HTMLInputElement) {
    selectedCity.length = 0;
    const inputText = input.value;
    const words = inputText.split(' ');
    if (words.length > 0) {
        const firstWord = words[0].toLowerCase();
        const cityName = words.length > 1 ? words.slice(1).join(' ') : words[0];
        if (firstWord === 'г' || firstWord.length > 3) {
            const cityObject = { city: cityName };
            selectedCity.push(cityObject);
        } else {
            const settlementObject = { settlement: cityName };
            selectedCity.push(settlementObject);
        }
    }
    if (adressInput) {
        adressInput.value = '';
        const event = new Event('input');
        adressInput.dispatchEvent(event);
    }
}

const handlePaymentMethods = (input: HTMLInputElement) => {
    const inputValue = input.value.toLowerCase();
    const paymentMethodsItems = document.querySelectorAll('.js-o-payment-item-label');

    paymentMethodsItems.forEach((methodItem) => {
        const methodInput = methodItem.querySelector<HTMLInputElement>('.js-o-payment-item-label-input');

        if (
            methodInput &&
            CHECK_PAYMENT_INPUT_VALUES.includes(methodInput.value) &&
            input.classList.contains('js-city-payment-handler')
        ) {
            if (
                inputValue.includes('москв') ||
                inputValue.includes('москов') ||
                inputValue.includes('питер') ||
                inputValue.includes('петер')
            ) {
                gsap.set(methodItem, {
                    display: 'block',
                });
            } else {
                gsap.set(methodItem, {
                    display: 'none',
                });
            }
        }
    });
};

const init = (inputGroupSelector: string) => {
    if (!inputGroupSelector) {
        return;
    }

    const inputGroup = document.querySelector<HTMLElement>(inputGroupSelector);

    const groupApiUrl = inputGroup?.dataset.href;

    if (!groupApiUrl) {
        return;
    }

    const autoCompleteInput = inputGroup?.querySelector<HTMLInputElement>('.js-input');
    const suggestionsContainer = inputGroup?.querySelector('.js-autocomplete-items');

    if (autoCompleteInput) {
        handlePaymentMethods(autoCompleteInput);
    }

    suggestionsContainer?.classList.add('address-autocomplete__list');
    suggestionsContainer?.classList.add('text-sm');
    suggestionsContainer?.classList.add('s-14');

    let debounceTimeout: NodeJS.Timeout;

    const handleInput = () => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        debounceTimeout = setTimeout(async () => {
            if (autoCompleteInput) {
                if (autoCompleteInput.classList.contains('js-city-payment-handler')) {
                    citySettlementCheck(autoCompleteInput);
                }
                handlePaymentMethods(autoCompleteInput);
            }

            const requestConfig = {
                query: autoCompleteInput?.value ?? '',
                count: 5,
            };

            if (selectedCity.length > 0 && autoCompleteInput?.classList.contains('js-address-handler')) {
                requestConfig.locations = selectedCity;
            }

            const request = await axios.post<IAutocompleteResponse>(groupApiUrl, requestConfig, {
                headers: {
                    Authorization: `Token ${API_KEY}`,
                },
            });

            if (request.status === 200) {
                if (inputGroupSelector === '.js-address-value-input-group') {
                    const suggestionsMarkup = request.data.suggestions
                        .map(
                            (suggestion) =>
                                `<button
                                type="button"
                                class="address-autocomplete__list-button js-address-autocomplete-list-item"
                            >
                                <span class="js-value address-autocomplete__list-value">${suggestion.value}</span>
                            </button>`,
                        )
                        .join('');

                    if (suggestionsContainer) {
                        suggestionsContainer.innerHTML = suggestionsMarkup;
                    }
                }
                if (inputGroupSelector === '.js-city-value-input-group') {
                    const addedCitiesAndSettlements = new Set();
                    const suggestionsMarkup = request.data.suggestions
                        .map((suggestion) => {
                            if (
                                suggestion.data.city !== null &&
                                !addedCitiesAndSettlements.has(suggestion.data.city) &&
                                suggestion.data.city.toLowerCase().includes(autoCompleteInput?.value.toLowerCase())
                            ) {
                                addedCitiesAndSettlements.add(suggestion.data.city);
                                return `
                            <button
                                type="button"
                                class="address-autocomplete__list-button js-address-autocomplete-list-item"
                            >
                                <span class="js-value address-autocomplete__list-value">${suggestion.data.city_type} ${suggestion.data.city}</span>
                            </button>
                            `;
                            }
                            if (
                                suggestion.data.settlement_with_type !== null &&
                                !addedCitiesAndSettlements.has(suggestion.data.settlement_with_type)
                            ) {
                                addedCitiesAndSettlements.add(suggestion.data.settlement_with_type);
                                return `
                            <button
                                type="button"
                                class="address-autocomplete__list-button js-address-autocomplete-list-item"
                            >
                                <span class="js-value address-autocomplete__list-value">${suggestion.data.settlement_type} ${suggestion.data.settlement}</span>
                            </button>
                            `;
                            }
                        })
                        .join('');
                    if (suggestionsContainer) {
                        suggestionsContainer.innerHTML = suggestionsMarkup;
                    }
                }
            }
        }, 300);
    };

    // Обработка ввода
    pageHandlers.set(autoCompleteInput, handleInput, 'input');

    // Обработка событий инпута и блока автокомплита для корректного отображения и подставления данных
    pageHandlers.set(
        autoCompleteInput,
        () => {
            suggestionsContainer?.classList.add('visible');
        },
        'focus',
    );
    pageHandlers.set(autoCompleteInput, (event) => event.stopPropagation());
    pageHandlers.set(document, () => {
        suggestionsContainer?.classList.remove('visible');
    });

    pageHandlers.set(suggestionsContainer, (event: Event) => {
        event.stopPropagation();

        if (autoCompleteInput) {
            autoCompleteInput.value = (event.target as HTMLElement).innerText.trim();
            if (autoCompleteInput.classList.contains('js-city-payment-handler')) {
                citySettlementCheck(autoCompleteInput);
            }
        }

        suggestionsContainer?.classList.remove('visible');

        if (autoCompleteInput) {
            handlePaymentMethods(autoCompleteInput);
        }
    });
};

const destroy = () => {
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
